'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$OpenToUpdate(item) {
  this.L0 = null;
  this.L0 = item;
}
export { $c_Lpresto_crud$OpenToUpdate as $c_Lpresto_crud$OpenToUpdate };
$p = $c_Lpresto_crud$OpenToUpdate.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$OpenToUpdate;
/** @constructor */
function $h_Lpresto_crud$OpenToUpdate() {
}
export { $h_Lpresto_crud$OpenToUpdate as $h_Lpresto_crud$OpenToUpdate };
$h_Lpresto_crud$OpenToUpdate.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_crud$OpenToUpdate) && $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_BoxesRunTime$().z(this.L0, x$0.L0)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "OpenToUpdate";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.L0;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_crud$OpenToUpdate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ji)));
}
export { $isArrayOf_Lpresto_crud$OpenToUpdate as $isArrayOf_Lpresto_crud$OpenToUpdate };
var $d_Lpresto_crud$OpenToUpdate = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$OpenToUpdate, "presto.crud$OpenToUpdate", ({
  ji: 1,
  ca: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_crud$OpenToUpdate as $d_Lpresto_crud$OpenToUpdate };
//# sourceMappingURL=presto.crud$-Open-To-Update.js.map
